module.exports = __webpack_public_path__ + "static/media/animation.7c526e3a.md";